import { Space } from "antd";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function FilterSection({ children, className = "" }: Props) {
  return (
    <Space
      size="small"
      className={`items-center flex-wrap table_filter_section ${className}`}
    >
      {children}
    </Space>
  );
}
